import { Star } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { SubtypeToolboxPlaceholderScaffold } from "../../../pages/actionModules/ActionModuleEditor/SubtypeEditor/SubtypeToolbox";
import { SubtypeDefinition } from "../actionModule";
import { Subtype } from "./subtype";
import EvaluationStarsSubtypeDetails from "../../../pages/incentivation/actionModules/incentivationTable/subtype/details/EvaluationStarsSubtypeDetails";
import { EvaluationStarsSubtypeDataModel } from "./evaluationStarsSubtype";
import EvaluationStarsSubtypeSummary from "../../../pages/incentivation/actionModules/incentivationTable/subtype/summary/EvaluationStarsSubtypeSummary";

export const EvaluationStarsSubtype: SubtypeDefinition = {
    name: "actionModules.subtypes.evaluationStars.name",
    type: Subtype.EvaluationStarsModuleSubtype,
    icon: <Star />,
    toolboxPlaceholder: () => <SubtypeToolboxPlaceholderScaffold
        icon={<Star />}
        name="actionModules.subtypes.evaluationStars.name" />,
    editorPreview: () => <Stack
      sx={{justifyContent: "center", gap: 1}}
      direction="row">
        <Star/><Star/><Star/><Star/><Star/>
    </Stack>,
    subtypeDataView: (props) => <EvaluationStarsSubtypeDetails
        subtype={props.subtype}
        subtypeData={props.subtypeData as EvaluationStarsSubtypeDataModel} />,
    subtypeDataSummaryView: (props) => <EvaluationStarsSubtypeSummary
        subtype={props.subtype}
        subtypeData={props.subtypeData as EvaluationStarsSubtypeDataModel} />,
    editableProperties: []
};
